<template>
  <listTemplate :class="'height__100vh'">
    <template #header>
      <headerTemplate>
        <template #filterByStatus>
          <div class="leftSection">
            <div class="header-title wrapper-content__main font-weight__bold">
              {{getPageTitle()}}
            </div>
          </div>
        </template>
      </headerTemplate>
    </template>

    <template #view>
      <div class="view">
        <listTemplate :classCustom="'list-docs wrapper-content__main soVBan'">
          <template #subHeader>
            <subHeader>
              <template #content>
                <div class="leftSection">
                  <el-button
                    size="medium"
                    type="success"
                    class="createNew"
                    @click="isOpenVbBookCreateDialog = true"
                  >
                    <div class="flex-row flex__center">
                      <i class="fas fa-file-plus"></i>
                      <span>&nbsp;&nbsp;THÊM MỚI</span>
                    </div>
                  </el-button>
                </div>
                <searchTemplate
                  :keyword="keyword"
                  @simpleSearch="simpleSearch"
                  :isDisableAdvanceSearch="true"
                >
                </searchTemplate>
              </template>
            </subHeader>
          </template>

          <template #body>
            <div class="list">
              <!-- header-title -->
              <div class="header-title flex-row flex__between margin-bottom-10">
                <div class="leftSection flex-row flex__left">
                  <div class="theTitle theTitle__lv5 padding-left-10">
                    <span class="stt padding-left-10">STT</span>
                  </div>
                  <div
                    class="theTitle theTitle__lv1 flex-row flex__left padding-left-10 clickable"
                    @click="doSort('bookName')"
                  >
                    Tên sổ
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'bookName'"
                    />
                  </div>
                </div>
                <div class="rightSection flex-row flex__left">
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__left padding-left-10 clickable"
                    @click="doSort('prefix')"
                    v-if="bookType == 1"
                  >
                    Ký hiệu văn bản
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'prefix'"
                    />
                  </div>
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__left padding-left-10 clickable"
                    @click="doSort('bookCurrentNumber')"
                  >
                    Số sổ hiện tại
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'bookCurrentNumber'"
                    />
                  </div>
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__left padding-left-10 clickable"
                    @click="doSort('vbBookStatus')"
                  >
                    Trạng thái
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'vbBookStatus'"
                    />
                  </div>
                </div>
              </div>
              <!-- list-docs -->
              <VuePerfectScrollbar
                class="scroll-area"
                :settings="perfectScrollbarSetting"
                infinite-wrapper
              >
                <div class="list-docs">
                  <div
                    v-for="(item, $itemIndex) in listBook"
                    :key="item.id"
                    class="item flex-row flex__between"
                    @click="viewDocInBook(item)"
                  >
                    <div class="leftSection flex-row flex__left">
                      <div class="theTitle__lv5">
                        <div class="flex-row flex__left">
                          <div class="section-check">
                            <span class="stt flex-row flex__center">{{$itemIndex + 1}}</span>
                          </div>
                          <i class="fas fa-archive color__smoke"></i>
                        </div>
                      </div>
                      <div class="theTitle__lv1 padding-left-10">
                        <div class="title-docs flex-col flex__left">
                          <div class="tt_1 clickable">{{item.bookName}}</div>
                        </div>
                      </div>
                    </div>
                    <div class="rightSection flex-row flex__right">
                      <div
                        class="theTitle__lv3 flex-row flex__left padding-left-10 font-size__small"
                        v-if="bookType ==1"
                      >
                        <div class="flex-row flex__left">
                          <i class="cellIcon color__silver fas fa-quote-left"></i>
                          {{item.prefix || '-'}}
                        </div>
                      </div>
                      <div class="theTitle__lv3 flex-row flex__left padding-left-10 font-size__small">
                        <div class="flex-row flex__right">
                          <i class="cellIcon color__silver fas fa-archive"></i>
                          {{item.bookCurrentNumber?(9>=item.bookCurrentNumber >= 1?
                          "0"+item.bookCurrentNumber:item.bookCurrentNumber):""
                          || '-'}}
                        </div>
                      </div>

                      <div
                        class="theTitle__lv3 flex-row flex__left padding-left-10 font-size__small"
                      >
                        <div class="flex-row flex__right">
                          <el-tag
                            size="mini"
                            :class="[
                              'priority',
                              getPriorityClass(item.vbBookStatus)
                            ]"
                          >{{ getStatusLabel(item.vbBookStatus) }}
                          </el-tag>
                        </div>
                      </div>

                      <div class="theQuickAction flex-row flex__right">
                        <el-tooltip
                          content="Cập nhật"
                          placement="top"
                        >
                          <i
                            class="action-icon bgAmbient__blue clickable fas fa-pencil-alt"
                            @click.stop="edit(item)"
                          ></i>
                        </el-tooltip>

                        <el-tooltip
                          content="Xóa"
                          placement="top"
                        >
                          <i
                            class="action-icon bgAmbient__red clickable fas fa-trash-alt"
                            @click.stop="xoa(item)"
                          ></i>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>

                  <infinite-loading
                    ref="infiniteLoading"
                    spinner="spiral"
                    @infinite="infiniteHandler"
                  >
                    <div slot="no-more"></div>
                    <div slot="no-results">Không có dữ liệu</div>
                  </infinite-loading>
                </div>
              </VuePerfectScrollbar>
            </div>
          </template>
        </listTemplate>
      </div>

      <VbBookCreateDialog
        :isOpen="isOpenVbBookCreateDialog"
        :vbBook="selectedBook"
        :bookType="bookType"
        v-if="isEnableVbBookCreateDialog"
        @closed="isEnableVbBookCreateDialog = false"
        @closeDialog="isOpenVbBookCreateDialog = false"
        @success="createDocSuccess"
      />

    </template>
  </listTemplate>
</template>
<script>
  import bookService from "../../services/bookService";
  import dateFormatter from "../../filters/dateFormatter";
  import InfiniteLoading from "vue-infinite-loading";
  import constants from "../../constants";
  import listTemplate from "../common/list";
  import headerTemplate from "../../components/header/main-header.vue";
  import searchTemplate from "../common/search";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import utils from "../../services/utils";
  import handleRequestErrorMixin from "../handleRequestErrorMixin";
  import goBackMixin from "../../mixins/goBackMixin";

  export default {
    mixins: [handleRequestErrorMixin, goBackMixin],
    components: {
      InfiniteLoading,
      listTemplate,
      headerTemplate,
      searchTemplate,
      VuePerfectScrollbar,
      subHeader: () => import('../../components/main/sub-header.vue'),
      dialogTemplate: () => import('../common/custom-dialog.vue'),
      SortCaret: () => import('../doc-out/SortCaret'),
      VbBookCreateDialog: () => import('./VbBookCreateDialog'),
    },

    filters: {dateFormatter},

    data() {
      return {

        keyword: null,
        sort: null,
        order: null,
        page: 0,
        size: 10,
        listBook: [],
        countListBook: null,

        isOpenVbBookCreateDialog: false,
        isEnableVbBookCreateDialog: false,
        selectedBook: null,

        deptCode: null,
        department: null,
        perfectScrollbarSetting: {maxScrollbarLength: 350},
        search: '',
        isCreateNew: false,
        isUpdate: false,
      }
    },

    computed: {
      userDeptRoleId() {
        return this.$route.params.userDeptRoleId;
      },
      bookType() {
        return this.$route.params.bookType
      },
    },

    watch: {
      bookType() {
        this.keyword = null;
        this.listBook = [];
        this.page = 0;
        this.countList();
        this.$nextTick(() => this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.reset());
      },
      isOpenVbBookCreateDialog(newValue) {
        newValue && (this.isEnableVbBookCreateDialog = newValue);
      },
      isEnableVbBookCreateDialog(newValue) {
        (!newValue) && (this.selectedBook = null);
      }
    },

    created: function () {
      this.registerEventBusForMaster(() => {
        console.log("goBack");
        this.doSearch();
      });
      this.initQuery();
    },

    destroyed() {
      this.unregisterEventBusForMaster();
    },

    methods: {
      xoa(item) {
        const h = this.$createElement;
        this.$msgbox({
          title: 'Thông báo',
          message: h('p', null, [
            h('span', null, `Bạn có chắc muốn xóa sổ "${item.bookName}"?`)
          ]),
          showCancelButton: true,
          confirmButtonText: 'Xóa',
          cancelButtonText: 'Không',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              bookService.delete(item.id).then(respone => {
                this.$message({message: "Xóa thành công", type: 'success', duration: 2000});
                this.doSearch();
              }).catch(error => this.commonHandleRequestError(error));
              setTimeout(() => {
                done();
              }, 30);
            } else {
              done();
            }
          }
        })
      },
      viewDocInBook(item) {
        if (item.bookType == constants.BOOK_TYPE.VB_DI) {
          let params = utils.merge(this.$route.params, {userDeptRoleId: this.userDeptRoleId})
          let query = utils.merge(this.$route.query, {bookId: item.id});
          this.$router.push({name: "vbDiDaVaoSo", params: params, query: query});
        } else {
          let params = utils.merge(this.$route.params, {userDeptRoleId: this.userDeptRoleId})
          let query = utils.merge(this.$route.query, {bookId: item.id});
          this.$router.push({name: "vbDaVaoSo", params: params, query: query});
        }
      },

      edit(item) {
        let query = utils.merge(this.$route.query, {
          bookType: item.bookType
        });
        let params = utils.merge(this.$route.params, {
          id: item.id
        });
        this.$router.push({
          name: this.bookType == constants.BOOK_TYPE.VB_DEN ? "quanlySoDenDetail" : "quanlySoDiDetail",
          params: params,
          query: query
        });
      },

      createDocSuccess() {
        this.isOpenVbBookCreateDialog = false;
        this.doSearch();
      },

      initQuery() {
        this.keyword = this.$route.query.keyword || null;
        this.sort = this.$route.query.sort || "updateTime";
        this.order = this.$route.query.order || "desc";
      },

      buildQuery() {

        let query = {
          keyword: this.keyword || undefined,
          sort: this.sort || "updateTime",
          order: this.order || "desc",
        };

        return query;
      },

      simpleSearch(keyword) {
        this.keyword = keyword;
        this.doSearch();
      },

      doSort(sort) {
        let order = (sort == this.sort) ? (this.order == "asc" ? "desc" : "asc") : "asc";
        this.sort = sort;
        this.order = order;
        this.doSearch();
      },

      doSearch() {
        let currentNameRouter = this.$route.name;
        this.$router.replace({name: currentNameRouter, params: this.$route.params, query: this.buildQuery()});
        this.listBook = [];
        this.page = 0;
        this.countList();
        this.$nextTick(() => this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.reset());
      },

      infiniteHandler($state) {
        this.list().then(items => {
          this.page += 1;
          items && items.length ? $state.loaded() : $state.complete();
        });
      },

      list() {
        let pageable = {page: this.page, size: this.size, sort: [this.sort, this.order].join(",")};

        return bookService
          .findAll({bookType: this.bookType, bookName: this.keyword, prefix: this.keyword}, pageable)
          .then(response => {
            let items = response.data;
            items && (this.listBook = this.listBook.concat(items));
            return items;
          })
      },

      countList() {
        bookService
          .count({bookType: this.bookType, bookName: this.keyword, prefix: this.keyword})
          .then(response => {
            this.countListBook = response.data;
          });
      },

      getPageTitle() {
        return this.bookType == constants.BOOK_TYPE.VB_DEN ? "Quản lý sổ đến" : "Quản lý sổ đi";
      },

      getPriorityClass(vbBookStatus) {
        switch (vbBookStatus) {
          case constants.VB_BOOK.STATUS.ACTIVE:
            return "lv4";
          case constants.VB_BOOK.STATUS.DEACTIVE:
            return "lv1";
          default:
            return null;
        }
      },

      getStatusLabel(vbBookStatus) {
        switch (vbBookStatus) {
          case constants.VB_BOOK.STATUS.ACTIVE:
            return "Hoạt động";
          case constants.VB_BOOK.STATUS.DEACTIVE:
            return "Không hoạt động";
          default:
            return null;
        }
      },
    }
  }

</script>
<style>
  /*.book-dialog {*/
  /*  border-radius: 6px;*/
  /*}*/

  /*.text-left {*/
  /*  text-align: left;*/
  /*}*/

  .el-input-number-custom > div > input {
    border: none;
    border-radius: 0px;
    border-bottom: 1px solid #dcdfe6;
    text-align: left !important;
    padding-left: 0 !important;
    font-size: 14px !important;
  }

  .el-input-number-custom > span {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/book/VbBookIndex.vue